// components/AlertDialog.jsx
import React, { useEffect, useState } from "react";
import { FaBell } from "react-icons/fa";

export default function AlertDialog({ isOpen, onClose, title = "Berhasil", message }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      const timer = setTimeout(() => setVisible(false), 1500); // animasi hilang
      const closeTimer = setTimeout(() => onClose(), 1500); // auto close
      return () => {
        clearTimeout(timer);
        clearTimeout(closeTimer);
      };
    }
  }, [isOpen, onClose]);

  //if (!isOpen) return null;

  return (
    <div className="fixed z-50 transform -translate-x-1/2 pointer-events-none top-20 left-1/2">
      <div
        className={`flex items-center max-w-md w-full bg-white border-l-4 border-green-500 shadow-xl rounded-lg p-4 space-x-4 pointer-events-auto transform transition-all duration-300 ${
          visible ? "translate-y-0 opacity-100" : "-translate-y-10 opacity-0"
        }`}
      >
        {/* Icon lonceng */}
        <div className="flex-shrink-0 text-green-500">
          <FaBell size={20} />
        </div>

        {/* Text */}
        <div className="flex flex-col">
          <h2 className="text-lg font-semibold text-green-700">{title}</h2>
          <p className="text-sm text-gray-700">{message}</p>
        </div>
      </div>
    </div>
  );
}
